import axios from "axios";
import { adminMainUrl } from "../../../Config";



//ff -> air -> export -> get query info by quotation
export const getOperationExpenseList = (token, user_id, job_order_id, current_page, queryParams) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_OPERATION_EXPENSE_LIST_REQUEST",
        });

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            search_text: "",
            trans_mode: "",
            trans_type: "",
            job_order_id: job_order_id,
            page: current_page,
        };
        params.forEach((value, key) => {
            requestBody[key] = value;
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/operation/expense/list`;
        try {
            axios.post(apiUrl, requestBody, config).then((res) => {
                dispatch({
                    type: "FIND_OPERATION_EXPENSE_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getOperationExpenseList function (redux):", err);
                dispatch({
                    type: "FIND_OPERATION_EXPENSE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getOperationExpenseList function:", error);
            dispatch({
                type: "FIND_OPERATION_EXPENSE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> get query info by quotation
export const getOperationExpenseRemarksList = (token, user_id, expense_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_OPERATION_EXPENSE_REMARKS_LIST_REQUEST",
        });


        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let requestBody = { expense_id: expense_id }
        let apiUrl = `${adminMainUrl}/api/jobOrder/operation/expense/view-remarks`;
        try {
            axios.post(apiUrl, requestBody, config).then((res) => {
                dispatch({
                    type: "FIND_OPERATION_EXPENSE_REMARKS_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getOperationExpenseRemarksList function (redux):", err);
                dispatch({
                    type: "FIND_OPERATION_EXPENSE_REMARKS_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getOperationExpenseRemarksList function:", error);
            dispatch({
                type: "FIND_OPERATION_EXPENSE_REMARKS_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//operation-expense-detail
export const getOperationExpenseDetail = (token, user_id, expense_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_OPERATION_EXPENSE_DETAIL_REQUEST",
        });


        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let requestBody = { expense_id: expense_id }
        let apiUrl = `${adminMainUrl}/api/jobOrder/operation/expense/view`;
        try {
            axios.post(apiUrl, requestBody, config).then((res) => {
                dispatch({
                    type: "FIND_OPERATION_EXPENSE_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getOperationExpenseDetail function (redux):", err);
                dispatch({
                    type: "FIND_OPERATION_EXPENSE_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getOperationExpenseDetail function:", error);
            dispatch({
                type: "FIND_OPERATION_EXPENSE_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

